import { getCrudApi } from "./CrudApi";

export const AgentCrudApi = getCrudApi("users");
export const SourceCrudApi = getCrudApi("sources");
export const SubscriptionCrudApi = getCrudApi("subscriptions");
export const StateCrudApi = getCrudApi("states");
export const LeadCrudApi = getCrudApi("leads");
export const CallCrudApi = getCrudApi("calls");
export const OrderCrudApi = getCrudApi("orders");
